import { render, staticRenderFns } from "./CurrencyField.vue?vue&type=template&id=22912f3e&scoped=true"
import script from "./CurrencyField.vue?vue&type=script&lang=ts"
export * from "./CurrencyField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22912f3e",
  null
  
)

export default component.exports